"use client";

import { useEffect, useState } from "react";
import { summarizePdf, type PdfSummary } from "@/workers/pdf-render";

/** Page count + first-page thumbnail for each PDF; missing until ready. */
export function usePdfSummaries(files: File[]): Map<File, PdfSummary> {
  const [map, setMap] = useState(() => new Map<File, PdfSummary>());
  useEffect(() => {
    let cancelled = false;
    (async () => {
      for (const file of files) {
        const summary = await summarizePdf(file);
        if (cancelled) return;
        setMap((old) =>
          old.get(file) ? old : new Map(old).set(file, summary),
        );
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [files]);
  return map;
}
